import api from './api';
import store from '@/store';
import axios from "axios";
import {userService} from '@/services'

const getCurrentLicence =() => userService.getLicence()
let fetchData = (config) => {
  let urlApiClientContact = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientContact + '?&licence=' + getCurrentLicence()
  let urlApiSupplierContact = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact + '?&licence=' + getCurrentLicence()
  let urlApiTaxes =   store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiTaxes + '?licence=' + getCurrentLicence()
  let urlGLAccounts = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiComptes + '?licence=' + getCurrentLicence()
  let urlDefaultTaxes= store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiTaxes + '?licence=' + getCurrentLicence() + '&codeTax=caqb'
  //let urlApiClientAccount= store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount + '?licence=' + getCurrentLicence() 

  let urlApiItemsSections = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItemSections + '?licence=' + getCurrentLicence() 

  let endpoints = [
          urlApiClientContact,
          urlApiSupplierContact,
          urlApiTaxes,
          urlGLAccounts,
          urlDefaultTaxes,
          //urlApiClientAccount,

          urlApiItemsSections
  ];

  return Promise.all(endpoints.map((endpoint) => api.get(endpoint, config))).then(
    axios.spread((...allData) => {
      allData = allData.map(rawData => { 
        return rawData.data;
      });
      store.dispatch('initAllData', allData)
    })
  );
}

let clearData = () => {
  store.dispatch('clearAllData')
}

let getClientAccountList = async() => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl).then(response => {
    store.dispatch('updateClients', response.data)
    return Promise.resolve(response);
  })
};


/******************************* */


let getCountClientAccount = () => {
  let apiUrlCount = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/count?licence=' + getCurrentLicence()
  return api.get(apiUrlCount).then(response => {
    return Promise.resolve(response.data.data);
  })
  .catch((error) => Promise.reject(error))
};

let getPaginatedClientAccountList = (start,end) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'?licence=' + getCurrentLicence()  +'&start='+start+'&end='+end
  return api.get(apiUrl).then(response => {
    return Promise.resolve(response);
  })
};



/******************************* */
let getClientAccount = (id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'?licence=' + getCurrentLicence() +'&id='+id
  return api.get(apiUrl)
};

let updateClientAccount = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl, obj)
};

let addClientAccount = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'?licence=' + getCurrentLicence()
  return api.post(apiUrl, obj)
};

let deleteClientAccount = (id) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'?licence=' + getCurrentLicence() + '&id=' + id + '&status=false'
  return api.delete(apiUrl)
};

/************* DEBUT - CONTACTS CLIENT ******************* */
let getClientContacts  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientContact +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl).then(response => {
    store.dispatch('updateClientContacts', response.data)
    return Promise.resolve(response);
  })
};
let getClientContact = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientContact +'?licence=' + getCurrentLicence()+'&id='+id
  return await api.get(apiUrl)
};
let addClientContact = (obj) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientContact +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj);
};
let updateClientContact = (obj) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientContact +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl, obj);
};
let deleteClientContact = (id) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientContact +'?licence=' + getCurrentLicence()+'&id='+id+'&status=false'
  return api.delete(apiUrl);
};
/************* FIN - CONTACTS CLIENT ****************** */


/************* DEBUT - CONTACTS FOURNISSEUR ******************* */
let getContactsSupplier  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl).then(response => {
    store.dispatch('updateSupplierContacts', response.data)
    return Promise.resolve(response);
  })
};
let getContactSupplier = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact +'?licence=' + getCurrentLicence()+'&id='+id
  return await api.get(apiUrl)
};
let addContactSupplier = (obj) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj);
};
let updateContactSupplier = (obj) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl, obj);
};
let deleteContactSupplier = (id) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact +'?licence=' + getCurrentLicence()+'&id='+id+'&status=false'
  return api.delete(apiUrl);
};
/************* FIN - CONTACTS FOURNISSEUR ****************** */


/************* DEBUT - FOURNISSEURS ******************* */
let getSuppliers  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl).then(response => {
    store.dispatch('updateSuppliers', response.data)
    return Promise.resolve(response);
  })
};
let getSupplier = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'?licence=' + getCurrentLicence()+'&id='+id
  return await api.get(apiUrl)
};
let addSupplier = (obj) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj);
};
let updateSupplier = (obj) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl, obj);
};
let deleteSupplier = (id) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'?licence=' + getCurrentLicence()+'&id='+id+'&status=false'
  return api.delete(apiUrl);
};
/************* FIN - FOURNISSEURS ****************** */

/************* DEBUT - ADDRESSES FOURNISSEUR ******************* */
let addSupplierAddress = (supplierId,obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'/addresses?licence=' + getCurrentLicence() +'&supplierid='+ supplierId
  return api.post(apiUrl,obj)
};
let updateSupplierAddress = (supplierId,obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'/addresses?licence=' + getCurrentLicence() +'&supplierid='+ supplierId
  return api.patch(apiUrl,obj)
};
let deleteSupplierAddress = (supplierId,id) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'/addresses?licence=' + getCurrentLicence() +'&supplierid='+ supplierId + '&addressid='+id+'&status=false'
  return api.delete(apiUrl)
};
/************* FIN - ADDRESSES FOURNISSEUR ****************** */


/************* DEBUT - ADDRESSES CLIENT ACCOUNT ******************* */
let addClientAccountAddress = (clientAccountId,obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/addresses?licence=' + getCurrentLicence() +'&clientAccountId='+ clientAccountId
  return api.post(apiUrl,obj)
};
let updateClientAccountAddress = (clientAccountId,obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/addresses?licence=' + getCurrentLicence() +'&clientAccountId='+ clientAccountId
  return api.patch(apiUrl,obj)
};
let deleteClientAccountAddress = (clientAccountId, addressid) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/addresses?licence=' + getCurrentLicence() +'&clientAccountId='+ clientAccountId + '&addressid='+addressid+'&status=false'
  return api.delete(apiUrl)
};
/************* FIN - ADDRESSES CLIENT ACCOUNT ****************** */

/************* DEBUT - CONTACTS CLIENT ACCOUNT ******************* */
let getClientAccountContacts = (clientAccountId) => {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/contacts?licence=' + getCurrentLicence() +'&clientAccountId='+ clientAccountId
  return api.get(apiUrl)
};
let attachContactToClient = (clientAccountId,obj) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/contacts?licence=' + getCurrentLicence() +'&clientAccountId='+ clientAccountId
  return api.post(apiUrl,obj)
};
let detachContactFromClient = (clientAccountId,contactId) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiClientAccount +'/contacts?licence=' + getCurrentLicence() +'&clientAccountId='+ clientAccountId + '&contactId='+contactId
  return api.delete(apiUrl)
};
/************* FIN - CONTACTS CLIENT ACCOUNT ****************** */

/************* DEBUT - CONTACTS DU FOURNISSEUR ******************* */
let getSupplierContacts = (supplierId) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'/contacts?licence=' + getCurrentLicence() +'&supplierid='+ supplierId
  return api.get(apiUrl)
};
let addSupplierContact = (obj) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplierContact +'?licence=' + getCurrentLicence() 
  return api.post(apiUrl,obj)
};
let attachContactToSupplier = (supplierId,obj) =>  { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'/contacts?licence=' + getCurrentLicence() +'&supplierid='+ supplierId
  return api.post(apiUrl,obj)
};

let detachContactFromSupplier = (supplierId,contactId) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiSupplier +'/contacts?licence=' + getCurrentLicence() +'&supplierid='+ supplierId + '&contactId='+contactId
  return api.delete(apiUrl)
};
/************* FIN - CONTACTS DU FOURNISSEUR ****************** */

/************* DEBUT - COMPTABILITE ******************* */

// GL Accounts
let getLGAccounts  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiComptes +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl).then(response => {
    store.dispatch('updateGLAccounts', response.data.data)
    return Promise.resolve(response.statusText);
  })
  .catch((error) => Promise.reject(error))
};

let getGlAccount = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiComptes +'?licence=' + getCurrentLicence()+'&id='+id
  console.log(apiUrl);
  return await api.get(apiUrl)
};

let updateGLAccount = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiComptes +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl,obj)
};
let addGLAccount = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiComptes +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj)
};
let deleteGLAccount = (id) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiComptes +'?licence=' + getCurrentLicence() + '&id=' + id + '&status=false'
  return api.delete(apiUrl)
};

// Exercices
let getExercices  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiExercises +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl)
};
let updateExercice = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiExercises +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl,obj)
};
let addExercice = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiExercises +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj)
};
let deleteExercice = (id) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiExercises +'?licence=' + getCurrentLicence() + '&id=' + id + '&status=false'
  return api.delete(apiUrl)
};
/************* FIN - COMPTABILITE ****************** */

/************* DEBUT - ITEMS ******************* */

let getProducts  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItems +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl).then(response => {
    store.dispatch('updateItems', response.data)
    return Promise.resolve(response.statusText);
  })
  .catch((error) => Promise.reject(error))
};

let getProduct = async(itemId) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItems +'?licence=' + getCurrentLicence()+'&id='+itemId
  return await api.get(apiUrl)
};

let getItemInfo = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItemInfo +'?licence=' + getCurrentLicence()+'&id='+id
  return await api.get(apiUrl)
};

let addProduct = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItems +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj)
};

let updateProduct = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItems +'?licence=' + getCurrentLicence()
  return api.patch(apiUrl,obj)
};

let deleteProduct = (id) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiItems +'?licence=' + getCurrentLicence() + '&id=' + id + '&status=false'
  return api.delete(apiUrl)
};
/************* FIN - ITEMS ****************** */

/************* DEBUT - CATEGORIES ******************* */
let getCategories  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiCategory +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl)
};

let getCategory = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiCategory +'?licence=' + getCurrentLicence()+'&id='+id
  return await api.get(apiUrl)
};

let addCategory = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiCategory +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj)
};

let updateCategory = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiCategory +'?licence=' + getCurrentLicence()
  console.log(apiUrl);
  return api.patch(apiUrl,obj)
};

let deleteCategory = (id) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiCategory +'?licence=' + getCurrentLicence() + '&id=' + id + '&status=false'
  return api.delete(apiUrl)
};
/************* FIN - CATEGORIES ****************** */


/************* DEBUT - DEPARTMENTS ******************* */
let getDepartments  = async() => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiDepartment +'?licence=' + getCurrentLicence()
  return await api.get(apiUrl)
};

let getDepartment = async(id) => { 
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiDepartment +'?licence=' + getCurrentLicence()+'&id='+id
  return await api.get(apiUrl)
};

let addDepartment = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiDepartment +'?licence=' + getCurrentLicence()
  return api.post(apiUrl,obj)
};

let updateDepartment = (obj) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiDepartment +'?licence=' + getCurrentLicence()
  console.log(apiUrl);
  return api.patch(apiUrl,obj)
};

let deleteDepartment = (id) =>  {
  let apiUrl = store.getters.getApiAdress + store.getters.getApiAdd.magasin.apiDepartment +'?licence=' + getCurrentLicence() + '&id=' + id + '&status=false'
  return api.delete(apiUrl)
};
/************* FIN - DEPARTMENTS ****************** */

export const dataService = {
  getClientAccountList,
  updateClientAccount,
  addClientAccount,
  getClientAccount,
  deleteClientAccount,

  fetchData,
  clearData,

  addClientAccountAddress,
  updateClientAccountAddress,
  deleteClientAccountAddress,

  addSupplierAddress,
  updateSupplierAddress,
  deleteSupplierAddress,

  getClientAccountContacts,
  attachContactToClient,
  detachContactFromClient,

  getSupplierContacts,
  addSupplierContact,
  detachContactFromSupplier,
  attachContactToSupplier,

  getClientContacts,
  getClientContact,
  addClientContact,
  updateClientContact,
  deleteClientContact,

  getContactsSupplier,
  getContactSupplier,
  addContactSupplier,
  updateContactSupplier,
  deleteContactSupplier,

  getSuppliers,
  getSupplier,
  addSupplier,
  updateSupplier,
  deleteSupplier,

  getCountClientAccount,
  getPaginatedClientAccountList,

  getLGAccounts,
  getGlAccount,
  updateGLAccount,
  addGLAccount,
  deleteGLAccount,

  getExercices,
  updateExercice,
  addExercice,
  deleteExercice,

  getProducts,
  getProduct,
  getItemInfo,
  addProduct,
  updateProduct,
  deleteProduct,

  getCategories,
  getCategory,
  addCategory,
  updateCategory,
  deleteCategory,

  getDepartments,
  getDepartment,
  addDepartment,
  updateDepartment,
  deleteDepartment

}
